/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export const MyAccordion = styled(Accordion)`
  box-shadow: 0px 1px 2px 0px rgba(30, 50, 70, 0.06), 0px 1px 3px 0px rgba(30, 50, 70, 0.1) !important;
  border: ${({ error }) => error === 'true' && `1px solid ${Palette.Red._300}`};
  .MuiAccordionSummary-content {
    margin: 0;
  }
  .MuiAccordionSummary-root {
    .sectionName {
      color: ${Palette.PrimaryGray._500};
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
    }

    :hover {
      .sectionName {
        color: ${Palette.PrimaryGray._700};
      }
      .expandIcon {
        color: ${Palette.Primary._500};
      }
    }
    ${({ expanded }) =>
      expanded &&
      css`
        .sectionName {
          color: ${Palette.PrimaryGray._900};
        }
        .expandIcon {
          color: ${Palette.Primary._500};
        }
        :hover {
          .sectionName {
            color: ${Palette.PrimaryGray._500};
          }
          .expandIcon {
            color: ${Palette.PrimaryGray._500};
          }
        }
      `}
  }
`;

export const MyAccordionSummary = styled(AccordionSummary)``;

export const StyledExpandMoreIcon = styled(NavigateNextIcon)`
  transition: transform 0.3s;
  transform: rotate(0deg);
  .MuiAccordionSummary-root.Mui-expanded & {
    transform: rotate(-90deg);
  }
`;
